// extracted by mini-css-extract-plugin
module.exports = {"container":"order-details_container__2ePBw"};